<template>
    <div class="">
      <div class="footer">
          <div class="foot">
            <div class="foot_top">
                <div class="foot_top_left">
                    <div class="foot_top_left_cent">{{common.company_name}}</div>
                    <div class="foot_top_left_cent">联系邮箱：{{common.email}}</div>
                    <div class="foot_top_left_cent">联系电话：{{common.phone}}</div>
                    <div class="foot_top_left_cent">联系地址：{{common.address}}</div>
                </div>
                <img class="foot_top_right" src="../../assets/images/qie/6.png" />
            </div>
            <div class="foot_bottom">
              <div class="foot_bottom_tt">版权所有：{{common.copyright}}</div>
              <div class="foot_bottom_tt" style="cursor: pointer;" @click="jump">备案号：{{common.filing_no}}</div>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
			...mapGetters({
				common: 'user/common', 
			}),
		},
	data() {
		return{
		
		}
	},
	methods:{
    jump(){
      window.open('https://beian.miit.gov.cn/')
    }
	},
	created(){
	
	}
}
</script>
<style scoped>
  .footer{
	  background-color: #1e1e1e;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .foot{
    min-width: 1200px;
    width: 69%;
  }
  .foot_top{
    padding-top: 35px;
    padding-bottom: 27px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #626262;
  }
  .foot_top_left{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 800px;
  }
  .foot_top_left_cent{
    width: 380px;
    font-size: 16px;
    color: #fefefe;
    margin-bottom: 12px;
  }
  .foot_top_right{
    width: 72px;
	  height: 72px;
  }
  .foot_bottom{
    height: 77px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .foot_bottom_tt{
    font-size: 15px;
    color: #d7d7d7;
  }
</style>





// WEBPACK FOOTER //
// footer.vue?676baf54